import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ index, label }) => (
  <div className="flex items-center gap-4">
    <span className="h-px w-10 bg-bronze" />
    <span className="text-xs font-medium uppercase tracking-[0.35em] text-bronze">
      {index} — {label}
    </span>
  </div>
);
